export default function (state) {
    let data = {};
    if (state.Id) data.Id = state.Id;
    if (state.StartDate) data.StartDate = {Serialized: state.StartDate};
    if (state.EndDate) data.EndDate = {Serialized: state.EndDate};
    if (state.IssueDate) data.IssueDate = {Serialized: state.IssueDate};
    if (state.Number) data.Number = state.Number;
    if (state.ContragentType) {
        switch (state.ContragentType) {
            case 'client':
                data.ClientId = state.ContragentId;
                break;
            case 'partner':
            case 'partnerLegal':
                data.PartnerId = state.ContragentId;
                break;
        }
    }
    if (state.PartnerLegalId) data.PartnerLegalId = state.PartnerLegalId;
    if (state.Sum) data.Sum = state.Sum;
    if (state.BankCommission) data.BankCommission = state.BankCommission;
    if (state.OwnerLegalEntityId) data.OwnerLegalEntityId = state.OwnerLegalEntityId;
    data.CurrencyId = state.CurrencyId;
    data.Type = state.Type;
    return data;
}